import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import es from 'vuetify/es5/locale/es'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es'
  },
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#616d73',
        secondary: '#616d73',
        accent: '#08b4b3',
        error: '#f44336'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js